import { defineComponent as _defineComponent } from 'vue'
import userAgent from '@/services/userAgent.service';
import { store } from '@/store';
import { computed, ref, useSlots } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockTextAndImageSideBySide',
  props: {
    backgroundColor: null,
    textColor: null,
    alignImageRight: { type: Boolean },
    alignTextCenter: { type: Boolean },
    verticalAlignTextCenter: { type: Boolean },
    displayTextAsQuote: { type: Boolean }
  },
  setup(__props: any) {



const isInEditMode = computed<boolean>(() => store.getters['app/isInEditMode']);
const runAnimations = ref<boolean>(userAgent.isPrerender);

function initAnimations(): void {
    runAnimations.value = true;
}

function hasBodyText(): boolean {
    return isSlotEmpty('body-text');
}

function hasImage(): boolean {
    return isSlotEmpty('image');
}

function hasImageCaption(): boolean {
    return isSlotEmpty('image-caption');
}

const slots = useSlots();

function isSlotEmpty(slotName: string): boolean {
    const slot = slots[slotName];
    return slot !== undefined;
}

return { __sfc: true,isInEditMode, runAnimations, initAnimations, hasBodyText, hasImage, hasImageCaption, slots, isSlotEmpty }
}

})